import { z } from 'zod';
import { EmptyValidationMessage, FormFieldSchema, mapRadioCardsField } from '@ninja/utilities';
import { HasEmiratesResponse } from '../../../../../common';
import { useAppPlatformContextOptions } from '../../../../../contexts/app';
import { prepareFieldError } from '../../../members/members-form/helpers/add-field-error';
import { DocumentsForm } from '../types';

const cardClassName = 'bg-white justify-center w-full !px-3 !py-1.5 !rounded-md !md:min-w-20';
const field = 'hasEmiratesId';

export const useHasEmiratesIdField = () => {
	const { translate: t } = useAppPlatformContextOptions();
	const getField = (memberId: string): FormFieldSchema<DocumentsForm> =>
		mapRadioCardsField({
			field: `${memberId}.${field}`,
			cards: [
				{
					id: HasEmiratesResponse.Yes,
					label: t('documents:fields.has-emirates-id.label-yes'),
					center: true,
					className: cardClassName,
				},
				{
					id: HasEmiratesResponse.No,
					label: t('documents:fields.has-emirates-id.label-no'),
					center: true,
					className: cardClassName,
				},
			],
			direction: 'row',
		});

	const getValidation = () =>
		z.number({
			required_error: EmptyValidationMessage,
		});

	const validate = (value: number | undefined, addFieldError: ReturnType<typeof prepareFieldError>) => {
		if (!value) {
			addFieldError({ field, message: EmptyValidationMessage });
		}
	};

	return {
		getField,
		getValidation,
		validate,
	};
};
